import { ChangeDetectorRef, Component } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { READABLE_SHORT_DATE_FORMAT } from '../../../../helpers/constants';
import { ReadableDatePipe } from '../../../../pipes/readable-date-pipe';
import { DateCellOptions } from '../../../entities/cell-options/cell-options.entity';
import { GetFieldPipe } from '../../../pipes/get-field.pipe';
import { TextCellComponent } from '../text-cell/text-cell.component';

@Component({
    standalone: false,
    selector: 'digihaven-short-date-cell',
    templateUrl: './short-date-cell.component.html',
    styleUrls: ['./short-date-cell.component.scss']
})
export class ShortDateCellComponent extends TextCellComponent<DateCellOptions> {
    valueAsDate$!: Observable<string>;

    constructor(fieldPipe: GetFieldPipe, cd: ChangeDetectorRef, readableDatePipe: ReadableDatePipe) {
        super(fieldPipe, cd);

        this.valueAsDate$ = combineLatest([this.value$, this.options$.pipe(startWith({ full: false }))]).pipe(
            map(([date, options]) => readableDatePipe.transform(date, options.full))
        );
    }
}
